<script lang="ts" setup>
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import InputExcelForm from '../inputExcelForm/InputExcelForm.vue';
const t = i18n.t;

const props = defineProps<{
  store: RegisterSettingStore;
}>();

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');

const emits = defineEmits<{
  (e: 'on-click-next'): void;
  (e: 'on-click-back'): void;
}>();

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-3.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-3.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-3__en.png') : imagesRequire('./register-input-step-flow-3.png');
  },
  {
    immediate: true,
  }
);

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadInput.headerCandidates.map((candidate) => candidate.value);
});
</script>

<template>
  <div class="finish-input">
    <div class="finish-input__title">{{ t('取引紐付け：タイトル') }}</div>

    <img :src="localedRegisterInputStepFlowImage" class="finish-input__progress" />

    <div class="finish-input__sub-title sub-title">
      <span class="sub-title__prefix"> {{ t('取引紐付け：本文') }}</span>
      <span class="sub-title__suffix"> {{ t('取引紐付け：注釈') }}</span>
    </div>

    <div class="finish-input__linking-container">
      <InputExcelForm
        :from="'FinishInput'"
        :selected-field-id="selectedFieldId"
        :suggestions="selectedFieldSuggestions"
        :input-file-type="state.uploadInput.inputFileType"
        :use-format-type="state.uploadInput.useFormatType"
        :alterable-header-infos="state.linkingInput.alternateHeaderInfos"
        :inlined-year-month-info="state.linkingInput.inlinedYearMonthInfo"
        :in-header-year-month-info="state.linkingInput.inHeaderYearMonthInfo"
      />
    </div>

    <div class="finish-input__button-container">
      <TextButton
        :button-style="'btn-secondary'"
        :size="'btn-md'"
        :on-click="onClickBackButton"
        :disabled="false"
        class="bulk-action-button-container__export-button"
      >
        {{ t('初期設定：戻るボタン') }}
      </TextButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.finish-input {
  display: grid;
  gap: 12px;

  background-color: $semanticWhite;
  border: 1px solid $borderDefault;
  border-radius: 4px;
  margin-top: 16px;
  padding: 16px;

  &__title {
    font-family: Noto Sans JP;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: $textDefault;
  }

  &__progress {
    justify-self: center;
  }

  &__linking-container {
    pointer-events: none;
    margin: 16px 0;
  }

  &__button-container {
    display: grid;
    justify-self: center;
    gap: 8px;
    grid-template-columns: repeat(2, fit-content(100%));
    margin-top: 16px;
  }
}

.sub-title {
  display: grid;
  gap: 16px;
  grid-template-rows: repeat(2, fit-content(100%));

  &__prefix {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: $textDefault;
  }

  &__suffix {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: $textDefault;
  }
}
</style>
